import { useMemo } from 'react'
import type { Product } from '@twlvxtwlv/tokenforge'
import { Button, Flex, Heading, SimpleGrid, Stack, Text } from '@chakra-ui/react'
import { ProductThumbnail } from './product-thumbnail'
import NextLink from 'next/link'
import { useTranslation } from 'next-i18next'

export interface SimilarProductsByGenreProps {
  headline: string | undefined
  subHeadline: string | undefined
  products: Product[]
  genre: string
  onTrackAllNftsClicked: () => void
}

export function SimilarProductsByGenre({
  headline = '',
  subHeadline = '',
  products,
  onTrackAllNftsClicked,
  genre,
}: SimilarProductsByGenreProps) {
  const { t } = useTranslation(['common'])
  const columns = useMemo(() => {
    return [
      products.length < 4 ? 1 : 2,
      products.length < 4 ? 1 : 2,
      products.length < 4 ? 1 : 2,
      products.length < 4 ? 1 : 2,
      3,
    ]
  }, [products])

  return (
    <Stack w="full" justify="center" align="center" px={4} py={14} gap={12} bg="white">
      <Flex direction="column" align="center" justify="center" gap={8} px={8}>
        <Heading
          textAlign="center"
          fontSize={['2xl', '2xl', '4xl']}
          textTransform="uppercase"
          fontWeight="400"
        >
          {headline}
        </Heading>
        <Text
          fontWeight="bold"
          textAlign="center"
          maxW={['full', '70%', '55%', '50%', '40%', '40%']}
        >
          {subHeadline}
        </Text>
      </Flex>
      {products?.length > 0 ? (
        <SimpleGrid
          w={['full', '80%', '60%', '50%', '70%']}
          maxW={['500px', '500px', '500px', '500px', 'full']}
          columns={columns}
          gap={4}
        >
          {products.map((product) => {
            return <ProductThumbnail product={product} key={product.code} imageSize="100vw" />
          })}
        </SimpleGrid>
      ) : null}

      <Button
        as={NextLink}
        variant="txtBlack"
        onClick={onTrackAllNftsClicked}
        href={`/gallery?genre=${genre}`}
        passHref
      >
        {t('navigation-all-nfts')}
      </Button>
    </Stack>
  )
}

SimilarProductsByGenre.displayName = 'SimilarProductsByGenre'
